import * as admin from 'firebase-admin';

if (!admin.apps.length) {
  admin.initializeApp();
}

const db = admin.firestore();

// Ensure we connect to emulator if env var is present
if (process.env.FIRESTORE_EMULATOR_HOST) {
  console.log(`[FirestoreAdmin] Connecting to emulator at ${process.env.FIRESTORE_EMULATOR_HOST}`);
  db.settings({
    host: process.env.FIRESTORE_EMULATOR_HOST,
    ssl: false,
  });
}

export const firestore = db;
